import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "@/lib/auth";
import logo from "@/assets/logo-circle.png";
import { supabase } from "../supabaseClient";
import { useTranslation } from "react-i18next";


export default function Welcome() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    let isMounted = true;

    async function decideNext() {
      // 1. 先查 Supabase session，看有没有登录过
      const { data, error } = await supabase.auth.getSession();
      const hasSession = !!data?.session;

      if (error) {
        console.error("getSession error:", error);
      }

      // 2. 保留一点时间显示 Welcome LOGO（例如 1200ms）
      setTimeout(() => {
        if (!isMounted) return;

        if (hasSession) {
          // 已登录过 → 直接进主页面
          navigate("/main", { replace: true });
        } else {
          // 没有登录记录 → 去登录页面
          navigate("/login", { replace: true });
        }
      }, 1200);
    }

    decideNext();

    return () => {
      isMounted = false;
    };
  }, [navigate]);
  
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-soft">
      <div className="text-center">
        <img 
          src={logo} 
          alt={t("app.name", { defaultValue: "Inner Gem" })} 
          className="w-32 h-32 mx-auto animate-breathe drop-shadow-lg"
        />
        <h1 className="mt-8 text-3xl font-bold text-primary">{t("app.name", { defaultValue: "Inner Gem" })}</h1>
        <p className="mt-2 text-muted-foreground">{t("welcome.tagline", { defaultValue: "Discover the wisdom within" })}</p>
      </div>
    </div>
  );
}
